<template>
  <div class="list-box">
    <div class="list-head" v-if="sort">
      排序：
      <span class="h-item" :class="isSort === 0 ? 'active' : ''" @click="handleSort(0)">上架时间</span>
      <span class="h-item" :class="isSort === 1 ? 'active' : ''" @click="handleSort(1)">阅读量</span>
    </div>
    <div class="list-body">
      <div class="bd-item" v-for="(item, index) of page.data" :key="item.id">
        <div class="s-index" :class="index > 2 ? 's-index-bg' : ''" v-if="order">
          <img src="@/assets/top1.png" v-if="index === 0">
          <img src="@/assets/top2.png" v-else-if="index === 1">
          <img src="@/assets/top3.png" v-else-if="index === 2">
          <span v-else>{{ index + 1 }}</span>
        </div>
        <div class="s-img" @click="$fun.openProductUrl(item.id)">
          <img :src="item.cover ? item.cover : '/static/img/default_image.jpg'" :alt="item.title" :title="item.title"
            onerror="this.src='/static/img/default_image.jpg'">
          <div v-if="item.attr == 1" class="ou-lf-tag">{{ $com.getBookOpenText(item.sourceOpenType) }}</div>
        </div>
        <div class="s-info">
          <div class="s-ti" :title="item.title" @click="$fun.openProductUrl(item.id)">{{ item.title }}</div>
          <div class="s-para" @click="$fun.openProductUrl(item.id)">
            <div class="para-item">{{ item.author }}<span></span></div>
            <div class="para-item">{{ item.publishTime }}<span></span></div>
            <div class="para-item">{{ item.publisher }}</div>
          </div>
          <div class="s-dec" @click="$fun.openProductUrl(item.id)" v-html="item.intro"></div>
          <div class="s-btns">
            <ButtonFollowView :model="item" />
            <ButtonCollectView :model="item" />
          </div>
          <div class="s-rate">
            <div class="s-item">
              <!-- <el-rate
                v-model="item.value"
                disabled
                show-score
                text-color="#ff9900"
                score-template="{value}">
              </el-rate> -->
            </div>
            <div class="s-item">{{name}}&nbsp;&nbsp;{{ item.readTotal }}</div>
          </div>
        </div>
      </div>
    </div>
    <PaginationView :page="page.page" :size="page.rows" :total="page.total" @changePage="page.changePage" />
  </div>
</template>

<script>
import ButtonFollowView from "common/ButtonFollowView";
import ButtonCollectView from "common/ButtonCollectView";
import PaginationView from "common/PaginationView";
export default {
  name: "NewBook",
  components: {
    ButtonFollowView,
    ButtonCollectView,
    PaginationView
  },
  props: {
    sort: {
      default: true,
      type: Boolean,
    },
    order: {
      default: false,
      type: Boolean,
    },
    id: {
      default: '3',
      type: String,
    }
  },
  data() {
    return {
      isSort: 0,
      listData: [],
      name: '阅读次数',
      type: '',
      tab: '',
      page: {
        order: "",
        sort: "desc",
        page: 1,
        rows: 10,
        data: [],
        total: 0,
        wheres: { id: this.$com.orgId(), title: this.id },
        load: (s) => {
          this.$bti.GetRankPage({ page: this.page.page, rows: this.page.rows, wheres: { orgId: this.$com.orgId(), rankId: this.type || 1 } }).then((res) => {
            if (res.code != 1) {
              return;
            }
            this.page.data = res.data.rows;
            this.page.total = res.data.total;
          });
        },
        changePage: (val) => {
          this.page.page = val;
          this.page.load();
        },
        changeSort: (item) => {
          this.page.page = 1;
          this.page.order = item.value;
          this.page.load();
        }
      },
    }
  },
  methods: {
    handleSort(index) {
      this.isSort = index;
    },
    load(s) {
      if (s == 2) {
         this.name = '收藏次数'
      }else if (s == 3) {
         this.name = '荐购次数'
      }else{
         this.name = '阅读次数'
      }
      this.type = s;
      this.page.page = 1;
      this.page.load();
    }
  },
  mounted: function () {
    this.page.load(1);
  }
}
</script>

<style lang="css" scoped>
.list-box {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 25px;
}

.list-head {
  padding-bottom: 10px;
  color: #B8B8B8;
}

.list-head .h-item {
  padding: 0 15px;
}

.list-head .h-item.active {
  color: #3C9B9E;
}

.list-body .bd-item,
.s-para,
.s-btns,
.s-rate {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.list-body {
  padding-top: 10px;
}

.list-body .bd-item {
  position: relative;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  margin-bottom: 30px;
}

.s-img {
  width: 110px;
  height: 145px;
  position: relative;
  cursor: pointer;
}

.s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251);
  -o-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.251)
}

.ou-lf-tag {
  border-top-right-radius: 0;
}

.s-info {
  margin-left: 20px;
  width: calc(100% - 120px);
  position: relative;
  cursor: pointer;
}

.s-rate {
  position: absolute;
  right: 0;
  top: 0;
}

.s-rate .s-item:nth-child(2) {
  line-height: 20px;
  color: #FFC53D;
  margin-left: 30px;
}

.s-para,
.s-dec {
  margin-bottom: 10px;
}

.s-ti {
  font-family: HarmonyOS Sans SC;
  color: #272636;
  width: 440px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 15px;
  margin-top: 5px;
  cursor: pointer;
}

.s-para {
  color: #B8B8B8;
}

.s-dec {
  color: #B8B8B8;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
  line-height: 1.4;
}

.item-btn {
  padding: 0px 15px;
  border-radius: 30px;
  color: #fff;
  margin-left: 15px;
  cursor: pointer;
  height: 24px;
  line-height: 24px;
}

.item-btn .icon {
  padding-right: 5px;
  position: relative;
  top: 0px;
}

.bd-item .para-item span {
  padding: 0 5px;
}

.s-index {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 11;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.s-index img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.s-index-bg {
  background-color: rgba(51, 51, 51, .8);
  color: #fff;
  font-weight: bold;
  border-radius: 0px 0px 12px 0px;
  padding: 0 10px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/common/List/RankingList.vue